import { render, staticRenderFns } from "./TrashAltIcon2.vue?vue&type=template&id=44eb262f"
import script from "./TrashAltIcon2.vue?vue&type=script&lang=js"
export * from "./TrashAltIcon2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports